
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getSchedulers = {
  getSchedulersList(params) {
    return axios.post(
      `/api/admin/schedulers/list`,
      qs.stringify(params)
    );
  },
  getSchedulersInfo(params) {
    return axios.post(
      `/api/admin/schedulers/info`,
      qs.stringify(params)
    );
  },
  saveSchedulers(params) {
    return axios.post(
      `/api/admin/schedulers/save`,
      qs.stringify(params)
    );
  },
  addSchedulers(params) {
    return axios.post(
      `/api/admin/schedulers/add`,
      qs.stringify(params)
    );
  },
  delSchedulers(params) {
    return axios.post(
      `/api/admin/schedulers/del`,
      qs.stringify(params)
    );
  },

  getSchedulersOptions(params) {
    return axios.post(
      `/api/admin/schedulers/options`,
      qs.stringify(params)
    );
  },
};
export default getSchedulers;
